import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postKyc = (params) => {
    return axios.post(`${backendHost}/api/admin/kyc/update`, params);
};

export {
    postKyc
}